import { Provider as ReduxProvider } from 'react-redux';
import type { ReactNode } from 'react';
import { store } from '@/store';
import { Toaster } from '@/shared/ui/sonner';
import { QueryProvider } from './QueryProvider';
import { SessionRestorer } from './SessionRestorer';

/**
 * Every provider the app needs, in dependency order.
 *
 * Redux is outermost because SessionRestorer reads from it.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ReduxProvider store={store}>
      <QueryProvider>
        <SessionRestorer>{children}</SessionRestorer>
        <Toaster richColors closeButton />
      </QueryProvider>
    </ReduxProvider>
  );
}
